import React, { useState } from 'react';

import Date_Wise_Ben_Ver from './Date_Wise_Ben_Ver'


const Date_Wise_Ben_Ver_List = ({ }) => {
    const [renderContent, setRenderContent] = useState(null);
    const [loading, setLoading] = useState(true); 
   
    const [selectedDate, setSelectedDate] = useState(() => {
        const today = new Date();
        return today.toISOString().split("T")[0];
    });

    const handleSubmit = () => {
        if (!selectedDate) {
            alert("Please select Date");
        } else {
            setRenderContent(
                <Date_Wise_Ben_Ver
    
                    date={selectedDate}
                />
            );
        }
    };

    return (
        <>
            <div className="wrapper row3">
                <div id="container">
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <table width="50%">
                            <thead>
                                <tr className="tableheader">
                                    <th colSpan={10}>Modify Aadhaar Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    
                                    <td>Select Date</td>
                                    <td>
                                        <input
                                            id="pos_ob_date"
                                            type="date"
                                            value={selectedDate}
                                            onChange={(e) => setSelectedDate(e.target.value)}
                                        />
                                    </td>

                                </tr>
                                <tr>
                                    <td colSpan={10} align="center">
                                        <button onClick={handleSubmit} className="button button2">
                                            Submit
                                        </button>
                                        <button className="button button2">
                                            Back
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <div id="loading" style={{ display: 'none', textAlign: 'center' }}>
                        <img src="images/progress.gif" alt="Loading" />
                    </div>
                    <br />
                    <div id="details1">{renderContent}</div>
                </div>
            </div>
        </>
    );
};

export default Date_Wise_Ben_Ver_List;
